const AUTH_TOKEN_KEY = 'auth_token';

const purgeLegacyTokenStorage = () => {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const getAuthToken = () => {
  purgeLegacyTokenStorage();
  return null;
};

export const setAuthToken = () => {
  purgeLegacyTokenStorage();
};

export const clearAuthToken = () => {
  purgeLegacyTokenStorage();
};
